import { BaseCustomFeatures } from './base';
import associationBoundaries, { associationBoundariesHighlightedStyle, associationBoundariesRegularStyle, } from '../styles/associations/association-boundaries';
import { i18n } from '@vendor/libs/lang/lang';
export class AssociationBoundaryFeatures extends BaseCustomFeatures {
    constructor(options = {}) {
        super('association-boundaries', {
            style: associationBoundaries,
            visibilityLabel: i18n.trans('map.features.association-boundaries.label'),
            ...options,
        });
        if (typeof options.visibilityElements == 'undefined') {
            this.setOptions({
                visibilityElements: [
                    {
                        name: this.getVisibilityName(),
                        label: this.options.visibilityLabel ?? this.getVisibilityName(),
                        children: [
                            {
                                name: 'association-boundaries-highlighted',
                                label: i18n.trans('map.features.association-boundaries.highlighted.label'),
                            },
                            {
                                name: 'association-boundaries-regular',
                                label: i18n.trans('map.features.association-boundaries.regular.label'),
                            },
                        ],
                    },
                ],
            });
        }
    }
    getLegendItems() {
        return [
            {
                geomType: 'Polygon',
                style: associationBoundariesRegularStyle('Nazwa'),
                title: i18n.trans('map.interface_elements.legend.association_boundaries.regular'),
            },
            {
                geomType: 'Polygon',
                style: associationBoundariesHighlightedStyle('Nazwa'),
                title: i18n.trans('map.interface_elements.legend.association_boundaries.highlighted'),
            },
        ];
    }
}
